import { CMS, MARKETING, OPERATIONS, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
export const buildFreeI18nKeyByProductLine = productLine => {
  switch (productLine) {
    case MARKETING:
      return 'merchCards.businessObjectives.suite.FREE.MARKETING.title';
    case SALES:
      return 'merchCards.businessObjectives.suite.FREE.SALES.title';
    case SERVICE:
      return 'merchCards.businessObjectives.suite.FREE.SERVICE.title';
    case CMS:
      return 'merchCards.businessObjectives.suite.FREE.CMS.title';
    case OPERATIONS:
      return 'merchCards.businessObjectives.suite.FREE.OPERATIONS.title';
    default:
      return '';
  }
};
export const buildStarterI18nKeyByProductLine = productLine => {
  switch (productLine) {
    case MARKETING:
      return 'merchCards.businessObjectives.suite.STARTER.MARKETING.title';
    case SALES:
      return 'merchCards.businessObjectives.suite.STARTER.SALES.title';
    case SERVICE:
      return 'merchCards.businessObjectives.suite.STARTER.SERVICE.title';
    case CMS:
      return 'merchCards.businessObjectives.suite.STARTER.CMS.title';
    case OPERATIONS:
      return 'merchCards.businessObjectives.suite.STARTER.OPERATIONS.title';
    default:
      return '';
  }
};